import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ILedgerAccount } from "src/models/Stores/LedgerAccount.models";

interface LedgerAccountState {
  ledgerAccounts: ILedgerAccount[];
  ledgerAccountToEdit: ILedgerAccount | null;
}

const initialState: LedgerAccountState = {
  ledgerAccounts: [],
  ledgerAccountToEdit: null,
};

const ledgerAccountSlice = createSlice({
  name: "LedgerAccount",
  initialState,
  reducers: {
    setLedgerAccountList: (state, action: PayloadAction<ILedgerAccount[]>) => {
      state.ledgerAccounts = action.payload;
    },
    concatListLedgerAccount: (
      state: LedgerAccountState,
      action: PayloadAction<ILedgerAccount[]>
    ) => {
      state.ledgerAccounts = [...state.ledgerAccounts.concat(action.payload)];
    },
    setLedgerAccountToEdit: (
      state,
      action: PayloadAction<ILedgerAccount | null>
    ) => {
      state.ledgerAccountToEdit = action.payload;
    },
    addLedgerAccount: (state, action: PayloadAction<ILedgerAccount>) => {
      state.ledgerAccounts.push(action.payload);
    },
    updateLedgerAccount: (state, action: PayloadAction<ILedgerAccount>) => {
      let itemIndex = state.ledgerAccounts.findIndex(
        item => item.ledgerAccountId === action.payload.ledgerAccountId
      );
      if (itemIndex !== -1) state.ledgerAccounts[itemIndex] = action.payload;
    },
    deleteLedgerAccount: (state, action: PayloadAction<number>) => {
      const newArray = state.ledgerAccounts.filter(
        item => item.ledgerAccountId !== action.payload
      );
      state.ledgerAccounts = newArray;
    },
  },
});

export const {
  setLedgerAccountList,
  concatListLedgerAccount,
  setLedgerAccountToEdit,
  addLedgerAccount,
  updateLedgerAccount,
  deleteLedgerAccount,
} = ledgerAccountSlice.actions;

export default ledgerAccountSlice.reducer;
